<template>
  <div>
    <div v-for="(data,index) of linkData" :key="index" class="mb-4 px-4 width-100 item-inline">
      <p class="font-bold center-align mb-1 shadow-text" :class="{'font-color-top-btn-up-text': !$vuetify.display.xs, 'font-color-top-btn-up-text-sp': $vuetify.display.xs}">{{data.text}}</p>
      <v-card tile elevation="3" class="link-card" @click="outWebJunp(data)" :color="data.color">

        <div class="link-card-inner">
          <div class="margin-auto">
            <v-icon size="38px" :color="data.fontColor" style="margin:8px">{{data.icon}}</v-icon>
            <div class="card-text-area" :class="{'font-color-bl': data.color === 'secondary', 'font-color-wh': data.color === 'primary'}">
              <div class="card-title font-bold font-large-sm line-height-m" :class="{'font-color-top-primary-btn-text' : data.fontColor === 'topPrimaryBtnText', 'font-color-top-secondary-btn-text' : data.fontColor === 'topSecondaryBtnText'}">{{data.title}}</div>
              <div class="card-sub-title font-medium-xl" :class="{'font-color-top-primary-btn-text' : data.fontColor === 'topPrimaryBtnText', 'font-color-top-secondary-btn-text' : data.fontColor === 'topSecondaryBtnText'}">{{data.subTitle}}</div>
            </div>
            <v-icon size="24px" :color="data.fontColor" style="margin:8px">mdi-arrow-right-drop-circle</v-icon>
          </div>
        </div>

      </v-card>

    </div>

  </div>
</template>

<script>
export default {
  name: 'link-card',
  prop: {
    data: {}
  },
  data: function () {
    return {
    }
  },
  methods: {
    outWebJunp: function (data) {
      if (data.isOut) {
        window.location.href = data.href
      } else {
        this.$router.push(data.href)
      }
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>

.font-color-bl{
  color: #2d2d2d;
}

.font-color-wh{
  color: #fff;
}

.text-vertical-middle{
  vertical-align: sub;
}

.link-card {
  height: 72px;
  overflow: hidden;
}

.link-card-inner{
  display: flex;
  height: 100%;
  position: relative;
}

.card-text-area {
  display: inline-block;
  width: 120px;
  vertical-align: middle;
}

.background-icon {
  position: absolute;
  top: 10px;
  left: -60px;
  opacity: 0.16;
  overflow: hidden;
}
.shadow-text{
  text-shadow: #000 1px 1px 3px;
}

</style>
